module.exports = __webpack_public_path__ + "static/media/so-icon__horns.8b06cd82.svg";